// Newest first. Empty fields are simply not shown.
const EXPERIENCE = [
    {
        company: 'Copley',
        href: 'https://www.copley.com',
        role: 'Software Engineer',
        type: 'Full-time',
        dates: '',
        summary: 'Building a demand engineering platform.',
        points: [],
    },
    {
        company: 'Cox Automotive',
        href: '',
        role: 'Software Engineer',
        type: 'Full-time',
        dates: '',
        summary: '',
        points: [],
    },
];

export default EXPERIENCE;
